export const firebaseConfig = {
  apiKey: "AIzaSyAMd0J-SNGdJzmqTygGEZcah-o9gXgL0ig",
  authDomain: "stackd-app-7e72b.firebaseapp.com",
  projectId: "stackd-app-7e72b",
  storageBucket: "stackd-app-7e72b.firebasestorage.app",
  messagingSenderId: "677509591720",
  appId: "1:677509591720:web:22a7b2e588ee8b3735889d",
  measurementId: "G-2HKFHJMQ4B"
};